import React from 'react'
import classNames from 'classnames'
import { AngleUpArrow } from '../assetsComponents'

/**
 * Sortable table header cell for non-react-table tables.
 * Matches TableHeaderCell styling used in Organization listings.
 */
const SortableHeaderCell = ({
  label,
  width,
  className = '',
  wrapperClassName = '',
  isSorted = false,
  isSortedDesc = false,
  onSort,
}) => {
  return (
    <th
      {...(width && { width })}
      className={classNames('cursor-pointer', className)}
      onClick={onSort}
      title=''>
      <div className={classNames('d-flex', wrapperClassName)}>
        <span>{label}</span>
        <span className='ml-2 inline-flex'>
          <AngleUpArrow
            className={classNames('vertical-align-initial', {
              'rotate-original-position': isSorted && isSortedDesc,
              'rotate-180': !isSorted || !isSortedDesc,
            })}
          />
        </span>
      </div>
    </th>
  )
}

export default SortableHeaderCell
